import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, 
//Alert,
Platform, Modal, } from 'react-native';
// import {BottomTabParamList} from '../Tools/config';
// import {NativeStackScreenProps} from '@react-navigation/native-stack';
// import {AccountStackParamList} from '../Tools/config';
import { Keyboard } from 'react-native';
import { register } from '../Tools/Web/apiPost';
//import Modal from 'react-native-modal';
import { useAuth } from '../Tools/AuthContext';
export const RegisterModal = ({ modalVisible, setModalVisible, }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [success, setSuccess] = useState(false);
    // const [customModalMessage, setCustomModalMessage] = useState('');
    // const [customModalVisible, setCustomModalVisible] = useState(false);
    //const [privateModalVisible, setPrivateModalVisible] = useState<boolean>(false);
    const [isSelected, setIsSelected] = useState(false);
    const act = useAuth();
    if (!act) {
        //console.log("ccccccccccccccccccccccccccccc");
        return _jsx(View, {});
    }
    const { 
    // accessToken,
    // setAccessToken,
    // refreshToken,
    // setRefreshToken,
    // needLogin,
    // setNeedLogin,
    // needLogo,
    // setNeedLogo,
    showModal, hideModal, } = act;
    const toggleSelection = () => {
        setIsSelected(!isSelected);
    };
    const handleRegister = async () => {
        Keyboard.dismiss();
        // 这里添加注册逻辑
        if (password !== confirmPassword) {
            //setCustomModalMessage('密码和验证密码不一致，请重新输入');
            setTimeout(() => {
                showModal('密码和验证密码不一致，请重新输入');
            }, 0);
            //setModalVisible(true);
            setPassword('');
            setConfirmPassword('');
            //await new Promise(resolve => setTimeout(resolve, 3000));
            return;
        }
        //可能还要检查邮箱是否符合规范
        let ok = await register(username, email, password);
        if (ok === true) {
            //setCustomModalMessage('注册成功，请前往登录');
            setSuccess(true);
            showModal('注册成功，请前往登录');
        }
        else {
            //setCustomModalMessage('注册失败，请重新尝试');
            setSuccess(false);
            showModal('注册失败，请重新尝试');
        }
        console.log('Registering:', { username, email, password });
    };
    const handleClose = () => {
        hideModal();
        if (success === true) {
            //自动跳转回登录界面
            //navigation.navigate('Login');
            setModalVisible(false);
        }
        else {
        }
    };
    const handleSelfClose = () => {
        hideModal();
        setModalVisible(false);
    };
    const handlePrivate = () => {
        act?.showPrivateModal();
    };
    const handleContract = () => {
        act?.showContractModal();
    };
    return (_jsx(View, { style: styles.centeredView, children: _jsx(Modal, { animationType: "slide", transparent: true, visible: modalVisible, onRequestClose: () => {
                setModalVisible(false);
            }, children: _jsx(View, { style: styles.centeredView, children: _jsxs(View, { style: styles.modalView, children: [_jsx(Text, { style: styles.title, children: "\u6CE8\u518C" }), _jsx(TextInput, { style: styles.input, placeholder: "\u7528\u6237\u540D", value: username, onChangeText: setUsername }), _jsx(TextInput, { style: styles.input, placeholder: "\u90AE\u7BB1", keyboardType: "email-address", value: email, onChangeText: setEmail }), _jsx(TextInput, { style: styles.input, placeholder: "\u5BC6\u7801", secureTextEntry: true, value: password, onChangeText: setPassword }), _jsx(TextInput, { style: styles.input, placeholder: "\u786E\u8BA4\u5BC6\u7801", secureTextEntry: true, value: confirmPassword, onChangeText: setConfirmPassword }), _jsx(TouchableOpacity, { onPress: handleRegister, style: [styles.button, !isSelected && Platform.OS != 'web' ? styles.buttonDisabled : null], disabled: !isSelected && Platform.OS != 'web', children: _jsx(Text, { style: styles.buttonText, children: "\u521B\u5EFA\u8D26\u53F7" }) }), _jsx(TouchableOpacity, { onPress: handleSelfClose, style: styles.button, children: _jsx(Text, { style: styles.buttonText, children: "\u5173\u95ED" }) }), Platform.OS != 'web' && (_jsxs(View, { style: styles.container, children: [_jsx(TouchableOpacity, { onPress: toggleSelection, style: styles.checkboxContainer, children: _jsx(View, { style: [styles.checkboxBase, isSelected && styles.checkboxChecked], children: isSelected && _jsx(Text, { style: styles.checkmark, children: "\u2713" }) }) }), _jsxs(View, { style: styles.textContainer, children: [_jsx(Text, { style: styles.text, children: "\u5DF2\u9605\u8BFB\u5E76\u540C\u610F" }), _jsx(TouchableOpacity, { onPress: handlePrivate, children: _jsx(Text, { style: styles.linkText, children: "\u9690\u79C1\u653F\u7B56" }) }), _jsx(Text, { style: styles.text, children: "\u548C" }), _jsx(TouchableOpacity, { onPress: handleContract, children: _jsx(Text, { style: styles.linkText, children: "\u7528\u6237\u534F\u8BAE" }) })] })] }))] }) }) }) }));
};
const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 22,
    },
    modalView: {
        width: '90%',
        minHeight: '60%',
        backgroundColor: 'white',
        borderRadius: 20,
        padding: 35,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        justifyContent: 'center', // 确保内部内容在垂直方向上居中
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        marginBottom: 20,
    },
    input: Platform.select({
        ios: {
            // iOS平台专用样式
            width: '80%',
            borderWidth: 1,
            borderColor: '#ddd',
            padding: 10,
            marginBottom: 10,
            borderRadius: 5,
        },
        android: {
            // Android平台专用样式
            width: '80%',
            borderWidth: 1,
            borderColor: '#ddd',
            padding: 10,
            marginBottom: 10,
            borderRadius: 5,
        },
        web: {
            // Web平台专用样式
            width: '40%',
            borderWidth: 1,
            borderColor: '#ddd',
            padding: 10,
            marginBottom: 10,
            borderRadius: 5,
        },
        default: {
            // 默认样式
            width: '80%',
            borderWidth: 1,
            borderColor: '#ddd',
            padding: 10,
            marginBottom: 10,
            borderRadius: 5,
        },
    }),
    button: {
        alignItems: 'center',
        backgroundColor: '#007bff',
        padding: 10,
        width: Platform.OS === 'web' ? '40%' : '80%',
        borderRadius: 0,
        marginBottom: 10,
    },
    buttonText: {
        color: '#ffffff',
    },
    privateButton: {
        alignItems: 'stretch',
        backgroundColor: 'transparent',
        padding: 0,
        width: Platform.OS === 'web' ? '40%' : '20%',
        borderRadius: 0,
        marginBottom: 10,
    },
    privateText: {
        color: 'blue',
        textDecorationLine: 'underline',
        textAlign: 'center', // 文字水平居中对齐
    },
    modalContent: {
        backgroundColor: 'white',
        padding: 22,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 4,
        borderColor: 'rgba(0, 0, 0, 0.1)',
    },
    modalButton: {
        marginTop: 10,
        fontSize: 18,
        color: '#007bff',
    },
    buttonDisabled: {
        backgroundColor: '#cccccc', // 灰色背景表示禁用状态
    },
    firstLine: {
        flexDirection: 'row',
        alignItems: 'center', // 确保第一行文字和复选框对齐
    },
    breakLine: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 10,
    },
    checkboxContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 5,
    },
    checkboxBase: {
        width: 20,
        height: 20,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 4,
        borderWidth: 2,
        borderColor: 'grey',
    },
    checkboxChecked: {
        backgroundColor: '#fff',
    },
    checkmark: {
        color: '#007BFF',
        fontSize: 14,
    },
    textContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    text: {
        fontSize: 14,
        color: '#333',
    },
    linkText: {
        fontSize: 14,
        color: 'blue',
        textDecorationLine: 'underline',
        marginHorizontal: 2, // 增加左右间距以保持一致
    },
});
export default RegisterModal;
